import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-core-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.css']
})
export class PageLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
